import React from 'react';
import { styled } from '@mui/material/styles';
import MuiSwitch from '@mui/material/Switch';
export const Switch = ({ checked, onChange, name, className, _sx, disabled = false, dataTestId, }) => {
    return (React.createElement(StyledSwitch, { checked: checked, onChange: onChange, name: name, className: className, sx: _sx, disabled: disabled, "data-testid": dataTestId }));
};
const StyledSwitch = styled(MuiSwitch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
    '&:active': {
        '& .MuiSwitch-thumb': {
            width: 15,
        },
        '& .MuiSwitch-switchBase.Mui-checked': {
            transform: 'translateX(9px)',
        },
    },
    '& .MuiSwitch-switchBase': {
        padding: 2,
        '&.Mui-checked': {
            transform: 'translateX(12px)',
            color: theme.palette.white,
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: theme.palette.primary.main,
            },
        },
    },
    '& .MuiSwitch-thumb': {
        width: 12,
        height: 12,
        borderRadius: 6,
        transition: theme.transitions.create(['width'], {
            duration: 200,
        }),
    },
    '& .MuiSwitch-track': {
        borderRadius: 8,
        opacity: 1,
        backgroundColor: theme.palette.gray,
        boxSizing: 'border-box',
    },
}));
